<template>
  <div class="row">
    <div class="col-12 form-group">
      <label for="perusahaan" class="form-label">Perusahaan</label>
      <selectize
        id="perusahaan"
        v-model="model.id_perusahaan"
        data-placeholder="Pilih Perusahaan"
        :disabled="disabled"
        :settings="selectConfig"
        @input="action"
      >
        <option
          :value="row.id"
          v-for="(row, i) in response.filter.perusahaans"
          :key="i"
        >
          {{ row.nama_perusahaan }}
        </option>
      </selectize>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    model: { default: null },
    response: { default: null },
    disabled: { default: false },
    action: {
      type: Function,
    },
  },
  data() {
    return {
      selectConfig: {
        maxItems: 99,
        plugins: ["remove_button"],
      },
    };
  },
  methods: {},
  mounted() {},
};
</script>